{
  "navigationRoutes": {
    "openCategory": "Abrir categoría",
    "visit": "Ir a"
  },
  "auth": {
    "agree": "Acepto",
    "createAccount": "Crear cuenta",
    "createNewAccount": "Crear cuenta nueva",
    "email": "Email",
    "login": "Iniciar sesión",
    "login_success": "Sesión iniciada correctamente",
    "login_error": "Correo o contraseña incorrectos",
    "password": "Contraseña",
    "recover_password": "Recuperar contraseña",
    "keep_logged_in": "Mantenerme conectado",
    "termsOfUse": "Términos de uso",
    "reset_password": "Restablecer contraseña"
  },
  "404": {
    "title": "Esta página se ha ido a pescar",
    "text": "Si crees que esto no es correcto, por favor envíanos un mensaje a ",
    "back_button": "Volver al tablero"
  },
  "typography": {
    "primary": "Estilos de texto primarios",
    "secondary": "Estilos de texto secundarios"
  },
  "dashboard": {
    "versions": "Versiones",
    "setupRemoteConnections": "Configurar conexiones remotas",
    "currentVisitors": "Visitantes actuales",
    "charts": {
      "trendyTrends": "Tendencias modernas",
      "showInMoreDetail": "Mostrar en más detalle",
      "showInLessDetail": "Mostrar en menos detalle",
      "loadingSpeed": "Velocidad de carga",
      "topContributors": "Principales contribuyentes",
      "showNextFive": "Mostrar los siguientes cinco",
      "commits": "Commit"
    },
    "info": {
      "componentRichTheme": "Tema rico en componentes",
      "completedPullRequests": "Solicitudes de pull completadas",
      "users": "Usuarios",
      "points": "Puntos",
      "units": "Unidades",
      "exploreGallery": "Explorar galería",
      "viewLibrary": "Ver biblioteca",
      "commits": "Commits",
      "components": "Componentes",
      "teamMembers": "Miembros del equipo"
    },
    "tabs": {
      "overview": {
        "title": "Visión general",
        "built": "Construido con el framework Vue.js",
        "free": "Totalmente gratuito para todos",
        "fresh": "Diseño fresco y nítido",
        "mobile": "Responsivo y optimizado para móviles",
        "components": "Toneladas de componentes útiles",
        "nojQuery": "Totalmente libre de jQuery"
      },
      "billingAddress": {
        "title": "Dirección de facturación",
        "personalInfo": "Información personal",
        "firstName": "Nombre y apellido",
        "email": "Email",
        "address": "Dirección",
        "companyInfo": "Información de la empresa",
        "city": "Ciudad",
        "country": "País",
        "infiniteConnections": "Conexiones infinitas",
        "addConnection": "Añadir conexión"
      },
      "bankDetails": {
        "title": "Detalles del banco",
        "detailsFields": "Campos de detalles",
        "bankName": "Nombre del banco",
        "accountName": "Nombre de la cuenta",
        "sortCode": "Código de ordenación",
        "accountNumber": "Número de cuenta",
        "notes": "Notas",
        "sendDetails": "Enviar detalles"
      }
    },
    "navigationLayout": "Diseño de navegación",
    "topBarButton": "Barra superior",
    "sideBarButton": "Barra lateral",
    "summaryError": "No se pudo cargar el resumen",
    "metrics": {
      "pendingBalance": "Saldo pendiente total",
      "paidThisMonth": "Pagado este mes",
      "overdue": "Facturas vencidas",
      "scheduledUpcoming": "Próximos pagos programados"
    },
    "byStatus": {
      "title": "Facturas por estado",
      "empty": "No hay facturas con saldo pendiente.",
      "total": "Total"
    },
    "cashflow": {
      "title": "Flujo de caja",
      "scheduled": "Programado",
      "executed": "Ejecutado",
      "range": "Últimos {days} días",
      "loadError": "No se pudo cargar el flujo de caja",
      "empty": "No hay datos de flujo de caja para este rango."
    },
    "overdue": {
      "title": "Facturas vencidas",
      "viewAll": "Ver todas",
      "empty": "No hay facturas vencidas. 🎉",
      "loadError": "No se pudieron cargar las facturas vencidas"
    },
    "inventoryValue": {
      "title": "Valor del inventario",
      "loadError": "No se pudo cargar el valor del inventario",
      "trendStart": "Inicio",
      "trendLoadError": "No se pudo cargar la tendencia del inventario"
    }
  },
  "language": {
    "brazilian_portuguese": "Portugués brasileño",
    "english": "Inglés",
    "spanish": "Español",
    "simplified_chinese": "Chino simplificado",
    "persian": "Persa"
  },
  "menu": {
    "buttons": "Botones",
    "timelines": "Líneas de tiempo",
    "dashboard": "Tablero",
    "preferences": "Preferencias",
    "settings": "Configuración",
    "settingsGeneral": "General",
    "posSyncStatus": "Sincronización POS",
    "recover-password-email": "Revisar correo",
    "users": "Usuarios",
    "login-singup": "Iniciar sesión/Registrarse",
    "providers": "Proveedores",
    "cartera": "Cartera",
    "invoices": "Facturas",
    "paymentSchedules": "Programación de pagos",
    "planilla": "Planilla",
    "inventario": "Inventario",
    "tarjetasRegalo": "Tarjetas Regalo",
    "programaPuntos": "Programa de Puntos",
    "clientesPuntos": "Clientes",
    "premios": "Premios",
    "configuracionPuntos": "Configuración",
    "pointOfSale": "Punto de Venta",
    "precios": "Precios",
    "categorias": "Categorías",
    "codigosBarra": "Códigos de Barra"
  },
  "messages": {
    "all": "Ver todos los mensajes",
    "new": "Nuevos mensajes de {name}",
    "mark_as_read": "Marcar como leído"
  },
  "navbar": {
    "messageUs": "Preguntas sobre desarrollo web:",
    "repository": "Repositorio GitHub"
  },
  "notifications": {
    "all": "Ver todas las notificaciones",
    "less": "Ver menos notificaciones",
    "mark_as_read": "Marcar como leída",
    "sentMessage": "{name} te envió un mensaje",
    "uploadedZip": "{name} subió un archivo Zip con {type}",
    "startedTopic": "{name} inició un nuevo tema",
    "markAllRead": "Marcar todas como leídas",
    "markAllReadSuccess": "Todas las notificaciones fueron marcadas como leídas",
    "markAllReadError": "No se pudieron marcar todas como leídas",
    "markReadError": "No se pudo marcar la notificación como leída",
    "loadError": "No se pudieron cargar las notificaciones",
    "empty": "No tienes notificaciones",
    "type": {
      "due_soon": "Próxima a vencer",
      "overdue": "Vencida"
    }
  },
  "user": {
    "language": "Cambiar Idioma",
    "logout": "Cerrar sesión",
    "profile": "Mi Perfil",
    "settings": "Configuración",
    "account": "Cuenta"
  },
  "search": {
    "placeholder": "Buscar..."
  },
  "vuestic": {
    "search": "Buscar",
    "noOptions": "No se encontraron elementos",
    "ok": "Aceptar",
    "cancel": "Cancelar",
    "uploadFile": "Subir archivo",
    "undo": "Deshacer",
    "dropzone": "Suelta los archivos aquí para subirlos",
    "fileDeleted": "Archivo eliminado",
    "closeAlert": "cerrar alerta",
    "backToTop": "volver al inicio",
    "toggleDropdown": "alternar menú desplegable",
    "carousel": "carrusel",
    "goPreviousSlide": "ir a la diapositiva anterior",
    "goNextSlide": "ir a la siguiente diapositiva",
    "goSlide": "ir a la diapositiva {index}",
    "slideOf": "diapositiva {index} de {length}",
    "close": "cerrar",
    "openColorPicker": "abrir selector de color",
    "colorSelection": "selección de color",
    "colorName": "color {color}",
    "decreaseCounter": "disminuir contador",
    "increaseCounter": "aumentar contador",
    "selectAllRows": "seleccionar todas las filas",
    "sortColumnBy": "ordenar columna por {name}",
    "selectRowByIndex": "seleccionar fila {index}",
    "resetDate": "restablecer fecha",
    "nextPeriod": "siguiente periodo",
    "switchView": "cambiar vista",
    "previousPeriod": "periodo anterior",
    "removeFile": "eliminar archivo",
    "reset": "restablecer",
    "pagination": "paginación",
    "goToTheFirstPage": "ir a la primera página",
    "goToPreviousPage": "ir a la página anterior",
    "goToSpecificPage": "ir a la página {page}",
    "goToSpecificPageInput": "ingresa el número de página",
    "goNextPage": "ir a la siguiente página",
    "goLastPage": "ir a la última página",
    "currentRating": "calificación actual {value} de {max}",
    "voteRating": "votar calificación {value} de {max}",
    "optionsFilter": "filtro de opciones",
    "splitPanels": "paneles divididos",
    "movePaginationLeft": "mover paginación a la izquierda",
    "movePaginationRight": "mover paginación a la derecha",
    "resetTime": "restablecer hora",
    "closeToast": "cerrar notificación",
    "selectedOption": "Opción seleccionada",
    "noSelectedOption": "No se ha seleccionado una opción",
    "breadcrumbs": "migas de pan",
    "counterValue": "valor del contador",
    "selectedDate": "fecha seleccionada",
    "selectedTime": "hora seleccionada",
    "progressState": "estado del progreso",
    "color": "color",
    "next": "Siguiente",
    "back": "Anterior",
    "finish": "Finalizar",
    "step": "paso",
    "progress": "progreso",
    "loading": "Cargando",
    "sliderValue": "El valor actual del control deslizante es {value}",
    "switch": "Cambiar",
    "inputField": "Campo de entrada",
    "fileTypeIncorrect": "El tipo de archivo es incorrecto",
    "select": "Seleccionar una opción"
  },
  "validation": {
    "required": "Este campo es obligatorio",
    "email": "Ingresa un correo electrónico válido",
    "positiveAmount": "El monto debe ser mayor a 0",
    "dueDateNotBeforeIssueDate": "La fecha de vencimiento debe ser igual o posterior a la fecha de emisión",
    "providerCode": "Debe tener exactamente 3 dígitos numéricos",
    "positiveInteger": "Debe ser un número entero mayor o igual a 1"
  },
  "common": {
    "cancel": "Cancelar",
    "save": "Guardar",
    "add": "Agregar",
    "edit": "Editar",
    "delete": "Eliminar",
    "back": "Volver",
    "resultsCount": "{count} resultados.",
    "unsavedChangesMessage": "El formulario tiene cambios sin guardar. ¿Deseas cerrarlo de todas formas?"
  },
  "providers": {
    "pageTitle": "Proveedores",
    "searchPlaceholder": "Buscar por nombre",
    "activeOnlyLabel": "Solo activos",
    "newButton": "Nuevo proveedor",
    "addTitle": "Agregar proveedor",
    "editTitle": "Editar proveedor",
    "deleteConfirmTitle": "Eliminar proveedor",
    "deleteConfirmMessage": "¿Estás seguro de que deseas eliminar a {name}?",
    "createdToast": "{name} fue creado",
    "updatedToast": "{name} fue actualizado",
    "deletedToast": "{name} fue eliminado",
    "loadError": "No se pudieron cargar los proveedores",
    "saveError": "No se pudo guardar el proveedor",
    "deleteError": "No se pudo eliminar el proveedor",
    "table": {
      "code": "Código",
      "name": "Nombre",
      "taxId": "NIT",
      "defaultMargin": "Margen",
      "contact": "Contacto",
      "email": "Email",
      "phone": "Teléfono",
      "invoices": "Facturas",
      "status": "Estado",
      "active": "Activo",
      "inactive": "Inactivo",
      "editAriaLabel": "Editar proveedor",
      "deleteAriaLabel": "Eliminar proveedor"
    },
    "form": {
      "code": "Código",
      "codeHint": "3 dígitos numéricos, ej: 001",
      "name": "Nombre",
      "taxId": "NIT",
      "contactName": "Nombre de contacto",
      "email": "Email",
      "phone": "Teléfono",
      "defaultMargin": "Margen de venta (%)",
      "defaultMarginHint": "Usado para calcular el precio de venta en Precios",
      "notes": "Notas",
      "active": "Activo"
    }
  },
  "precios": {
    "pageTitle": "Precios",
    "categoryLabel": "Categoría",
    "formTitle": "Calcular precio",
    "form": {
      "reference": "Referencia",
      "labelDetail": "Descripción del producto",
      "labelDetailPlaceholder": "Camisa manga larga",
      "quantity": "Cantidad de unidades",
      "quantityPlaceholder": "12",
      "costPrice": "Precio de costo",
      "includesIva": "¿El costo ya incluye IVA?"
    },
    "result": {
      "ivaIncluded": "IVA incluido",
      "ivaNotIncluded": "IVA no incluido"
    },
    "invoiceFlow": {
      "invoiceLabel": "Factura",
      "invoiceSearchPlaceholder": "Busca por número de factura",
      "providerLabel": "Proveedor",
      "balancePrefix": "Saldo",
      "selectInvoicePrompt": "Selecciona una factura para agregar productos a su detalle.",
      "loadInvoicesError": "No se pudieron cargar las facturas",
      "addToListButton": "Agregar a la lista",
      "pendingTitle": "Productos agregados a esta factura",
      "removePendingAriaLabel": "Quitar de la lista",
      "saveAllButton": "Guardar productos en la factura",
      "savedAllToast": "Se guardaron {count} productos en la factura",
      "saveAllError": "No se pudieron guardar todos los productos ({count} guardados antes del error) — revisa el mensaje e intenta de nuevo con el resto"
    },
    "historyTitle": "Historial de precios",
    "table": {
      "category": "Categoría",
      "reference": "Referencia",
      "barcode": "Código de barra",
      "labelDetail": "Descripción",
      "quantity": "Cantidad",
      "costPrice": "Costo",
      "iva": "IVA",
      "margin": "Margen",
      "salePrice": "Precio de venta",
      "updatedAt": "Última actualización",
      "deleteAriaLabel": "Eliminar precio"
    },
    "emptyHistory": "Este proveedor todavía no tiene precios calculados.",
    "deletedToast": "Precio de {reference} eliminado",
    "deleteConfirmTitle": "Eliminar precio",
    "deleteConfirmMessage": "¿Estás seguro de que deseas eliminar el precio de {reference}?",
    "loadError": "No se pudo cargar el historial de precios",
    "deleteError": "No se pudo eliminar el precio"
  },
  "categorias": {
    "pageTitle": "Categorías",
    "newButton": "Nueva categoría",
    "addTitle": "Agregar categoría",
    "editTitle": "Editar categoría",
    "deleteConfirmTitle": "Eliminar categoría",
    "deleteConfirmMessage": "¿Estás seguro de que deseas eliminar la categoría {name}?",
    "createdToast": "{name} fue creada",
    "updatedToast": "{name} fue actualizada",
    "deletedToast": "{name} fue eliminada",
    "loadError": "No se pudieron cargar las categorías",
    "saveError": "No se pudo guardar la categoría",
    "deleteError": "No se pudo eliminar la categoría",
    "empty": "Todavía no hay categorías creadas.",
    "table": {
      "name": "Nombre",
      "code": "Código",
      "editAriaLabel": "Editar categoría",
      "deleteAriaLabel": "Eliminar categoría"
    },
    "form": {
      "name": "Nombre",
      "code": "Código",
      "codeHint": "3 dígitos numéricos, ej: 001"
    }
  },
  "codigosBarra": {
    "pageTitle": "Códigos de Barra",
    "providerLabel": "Proveedor",
    "categoryFilterLabel": "Categoría (opcional)",
    "selectProviderPrompt": "Selecciona un proveedor para ver sus productos.",
    "selectAllLabel": "Seleccionar todos",
    "quantityLabel": "Cantidad",
    "printButton": "Imprimir {count} etiquetas",
    "printZebraButton": "Imprimir con Zebra ({count})",
    "printBrowserButton": "Imprimir (navegador, respaldo)",
    "printBusinessName": "Sinutech Pagos",
    "selectProductAriaLabel": "Seleccionar {reference}",
    "empty": "Este proveedor no tiene productos con categoría asignada. Asigna una categoría desde Precios para que aparezcan aquí.",
    "loadError": "No se pudieron cargar los productos",
    "zebraPrintSuccess": "Se enviaron {count} etiquetas a la impresora Zebra.",
    "zebraNotReady": "La impresora no está lista: {reason}",
    "zebraPrintTimeout": "La impresora tardó más de lo esperado en responder. Se alcanzaron a enviar {sent} de {total} etiquetas antes de esto — revisa la impresora antes de volver a intentar, para no duplicar las que ya salieron.",
    "zebraConnectionError": "No se pudo conectar con Zebra Browser Print. Verifica que la aplicación esté instalada y en ejecución, o usa el botón de respaldo."
  },
  "cartera": {
    "pageTitle": "Cartera",
    "searchPlaceholder": "Buscar proveedor",
    "balanceLabel": "Saldo pendiente",
    "emptyList": "No hay proveedores para mostrar.",
    "noResults": "No se encontraron proveedores.",
    "loadError": "No se pudo cargar la cartera",
    "backButton": "Volver a Cartera",
    "taxId": "NIT",
    "summary": {
      "totalInvoiced": "Total facturado",
      "totalPaid": "Total pagado",
      "totalBalance": "Saldo pendiente"
    },
    "transactionsTitle": "Historial de transacciones",
    "table": {
      "date": "Fecha",
      "type": "Tipo",
      "invoiceNumber": "N° Factura",
      "description": "Descripción",
      "debit": "Cargo",
      "credit": "Abono",
      "balance": "Saldo"
    },
    "type": {
      "compra": "Compra",
      "pago": "Pago"
    },
    "emptyTransactions": "Sin movimientos registrados.",
    "detailLoadError": "No se pudo cargar el estado de cuenta del proveedor"
  },
  "invoices": {
    "pageTitle": "Facturas",
    "statusPlaceholder": "Estado",
    "allStatuses": "Todos los estados",
    "providerPlaceholder": "Proveedor",
    "overdueOnlyLabel": "Solo vencidas",
    "excludedOnlyLabel": "Mostrar excluidas de alertas",
    "discountsOrPriorityOnlyLabel": "Mostrar solo con descuento o prioridad",
    "newButton": "Nueva factura",
    "addTitle": "Agregar factura",
    "editTitle": "Editar factura",
    "deleteConfirmTitle": "Eliminar factura",
    "deleteConfirmMessage": "¿Estás seguro de que deseas eliminar la factura {number}?",
    "createdToast": "Factura {number} creada",
    "updatedToast": "Factura {number} actualizada",
    "deletedToast": "Factura {number} eliminada",
    "loadError": "No se pudieron cargar las facturas",
    "saveError": "No se pudo guardar la factura",
    "deleteError": "No se pudo eliminar la factura",
    "status": {
      "pendiente": "Pendiente",
      "parcial": "Parcial",
      "pagada": "Pagada",
      "vencida": "Vencida"
    },
    "table": {
      "number": "N° Factura",
      "provider": "Proveedor",
      "issueDate": "Fecha emisión",
      "dueDate": "Fecha vencimiento",
      "amount": "Monto",
      "balance": "Saldo",
      "status": "Estado",
      "overdueTooltip": "Fecha de vencimiento superada",
      "excludedFromAlertsTooltip": "Excluida de alertas de vencimiento",
      "discountTooltip": "Descuento del {percentage}% si se paga antes del {date} (ahorro: {amount})",
      "priorityTooltip": "Factura marcada como prioritaria",
      "editAriaLabel": "Editar factura",
      "deleteAriaLabel": "Eliminar factura"
    },
    "form": {
      "provider": "Proveedor",
      "invoiceNumber": "N° Factura",
      "issueDate": "Fecha de emisión",
      "dueDate": "Fecha de vencimiento",
      "amount": "Monto",
      "description": "Descripción",
      "amountLockedNote": "Esta factura ya tiene pagos registrados, por lo que su monto no se puede modificar aquí.",
      "excludeFromAlerts": "Excluir de alertas de vencimiento",
      "alertExclusionReason": "Motivo",
      "alertExclusionReasonPlaceholder": "Ej: acuerdo de pago, proveedor cerrado, etc.",
      "alertExclusionReasonHint": "Se recomienda documentar el motivo, aunque no es obligatorio.",
      "discountSectionTitle": "Descuento por pronto pago",
      "discountDays": "Plazo del descuento",
      "noDiscount": "Sin descuento",
      "discountDaysOption": "{days} días",
      "discountPercentage": "Porcentaje de descuento",
      "discountPercentageRangeError": "El porcentaje debe estar entre 0 y 100",
      "prioritySectionTitle": "Prioridad manual",
      "markAsPriority": "Marcar como prioritaria",
      "priorityReason": "Motivo",
      "priorityReasonPlaceholder": "Ej: Alta rotación"
    },
    "payments": {
      "viewAriaLabel": "Ver pagos",
      "title": "Pagos de la factura {number}",
      "summary": {
        "amount": "Monto total",
        "balance": "Saldo pendiente"
      },
      "historyTitle": "Historial de pagos",
      "noPayments": "Todavía no hay pagos registrados para esta factura.",
      "fullyPaidMessage": "Esta factura ya está completamente pagada.",
      "amountExceedsBalance": "El monto no puede exceder el saldo pendiente ({balance})",
      "createdToast": "Pago registrado correctamente",
      "deletedToast": "Pago eliminado correctamente",
      "loadError": "No se pudieron cargar los pagos",
      "saveError": "No se pudo registrar el pago",
      "deleteError": "No se pudo eliminar el pago",
      "deleteConfirmTitle": "Eliminar pago",
      "deleteConfirmMessage": "¿Estás seguro de que deseas eliminar el pago de {amount}?",
      "table": {
        "date": "Fecha",
        "amount": "Monto",
        "method": "Método",
        "notes": "Notas",
        "createdBy": "Registrado por",
        "deleteAriaLabel": "Eliminar pago"
      },
      "form": {
        "title": "Registrar abono",
        "amount": "Monto",
        "paymentDate": "Fecha de pago",
        "paymentMethod": "Método de pago",
        "notes": "Notas",
        "submit": "Registrar pago",
        "methods": {
          "transfer": "Transferencia",
          "cash": "Efectivo",
          "check": "Cheque",
          "card": "Tarjeta",
          "other": "Otro"
        }
      }
    },
    "items": {
      "viewAriaLabel": "Detalle de productos",
      "title": "Detalle de productos — factura {number}",
      "detailTitle": "Productos comprados",
      "noItems": "Todavía no hay productos en el detalle de esta factura.",
      "addFromPreciosHint": "Los productos se agregan desde el módulo de Precios, seleccionando esta factura ahí.",
      "totalLabel": "Total del detalle",
      "loadError": "No se pudo cargar el detalle de productos",
      "refreshAriaLabel": "Actualizar estado",
      "sendButton": "Enviar a POS",
      "resendButton": "Reenviar a POS",
      "sendConfirmTitle": "Enviar factura a Sinutech POS",
      "sendConfirmMessage": "Se registrará esta factura como una compra en el POS, con los productos del detalle. ¿Deseas continuar?",
      "resendConfirmTitle": "Reenviar factura a Sinutech POS",
      "resendConfirmMessage": "Esta factura ya fue enviada al POS el {date}. Si el detalle de productos cambió después de ese envío, el POS NO reflejará esos cambios — un reenvío con el mismo identificador se ignora como duplicado. ¿Deseas reenviarla de todas formas?",
      "queuedToast": "Envío a POS en cola — el resultado se verá reflejado en unos segundos",
      "sendError": "No se pudo poner en cola el envío a POS",
      "sentAt": "Enviada el {date}",
      "posSync": {
        "never": "Sin enviar a POS",
        "queued": "En cola para enviar a POS",
        "sent": "Enviada a POS",
        "failed": "Error al enviar a POS"
      },
      "table": {
        "product": "Producto",
        "quantity": "Cantidad",
        "unitCost": "Costo unitario",
        "subtotal": "Subtotal"
      }
    }
  },
  "paymentSchedules": {
    "pageTitle": "Programación de pagos",
    "statusPlaceholder": "Estado",
    "allStatuses": "Todos los estados",
    "upcomingOnlyLabel": "Solo próximas",
    "newButton": "Nueva programación",
    "addTitle": "Nueva programación",
    "editTitle": "Editar programación",
    "deleteConfirmTitle": "Eliminar programación",
    "deleteConfirmMessage": "¿Estás seguro de que deseas eliminar esta programación de pago?",
    "createdToast": "Programación creada correctamente",
    "updatedToast": "Programación actualizada correctamente",
    "deletedToast": "Programación eliminada correctamente",
    "executedToast": "Pago ejecutado correctamente",
    "loadError": "No se pudieron cargar las programaciones",
    "saveError": "No se pudo guardar la programación",
    "deleteError": "No se pudo eliminar la programación",
    "executeError": "No se pudo ejecutar la programación",
    "status": {
      "programado": "Programado",
      "ejecutado": "Ejecutado",
      "omitido": "Omitido"
    },
    "table": {
      "scheduledDate": "Fecha programada",
      "invoice": "Factura",
      "amount": "Monto programado",
      "status": "Estado",
      "overdueTooltip": "La fecha programada ya pasó",
      "executeAriaLabel": "Ejecutar",
      "editAriaLabel": "Editar programación",
      "deleteAriaLabel": "Eliminar programación"
    },
    "form": {
      "provider": "Proveedor",
      "invoice": "Factura",
      "invoiceOption": "{number} - {provider} - Saldo: {balance}",
      "selectProviderFirst": "Selecciona un proveedor primero",
      "noInvoicesForProvider": "Este proveedor no tiene facturas pendientes",
      "scheduledDate": "Fecha programada",
      "scheduledAmount": "Monto programado",
      "amountExceedsBalanceHint": "El monto supera el saldo pendiente de la factura ({balance}). El backend lo permite, pero revisa que sea correcto."
    },
    "execute": {
      "title": "Ejecutar programación",
      "description": "Esto registrará un pago real de {amount} para la factura {number}.",
      "paymentMethod": "Método de pago",
      "notes": "Notas",
      "confirm": "Ejecutar pago"
    }
  },
  "planilla": {
    "pageTitle": "Planilla",
    "yearLabel": "Año",
    "yearTotalLabel": "Total {year}",
    "totalLabel": "Total",
    "empty": "No hay facturas pendientes registradas para este año.",
    "loadError": "No se pudo cargar la planilla",
    "table": {
      "provider": "Proveedor",
      "balance": "Saldo pendiente"
    }
  },
  "inventario": {
    "pageTitle": "Inventario",
    "currentValueLabel": "Valor actual del inventario",
    "loadError": "No se pudo cargar el valor del inventario",
    "form": {
      "title": "Registrar movimiento",
      "typeLabel": "Tipo de movimiento",
      "typeInitial": "Valor inicial",
      "typeSale": "Venta del día",
      "typePurchase": "Compra nueva",
      "amount": "Monto",
      "date": "Fecha",
      "description": "Descripción",
      "descriptionPlaceholder": "Opcional",
      "submitButton": "Registrar movimiento",
      "saveError": "No se pudo registrar el movimiento",
      "successToast": {
        "initial": "Valor inicial registrado — se sumó al inventario.",
        "sale": "Venta del día registrada — se restó del inventario.",
        "purchase": "Compra nueva registrada — se sumó al inventario."
      }
    }
  },
  "tarjetasRegalo": {
    "pageTitle": "Tarjetas Regalo",
    "loadError": "No se pudieron cargar las tarjetas regalo",
    "searchPlaceholder": "Buscar por código",
    "activeOnlyLabel": "Solo activas",
    "newButton": "Nueva tarjeta regalo",
    "createdToast": "Tarjeta {code} creada",
    "createError": "No se pudo crear la tarjeta regalo",
    "loadedToast": "Saldo cargado a la tarjeta {code}",
    "redeemedToast": "Saldo redimido de la tarjeta {code}",
    "checkBalance": {
      "title": "Consultar saldo",
      "codeLabel": "Código de la tarjeta",
      "button": "Consultar",
      "customerLabel": "Cliente",
      "balanceLabel": "Saldo disponible",
      "notFound": "No se encontró una tarjeta con ese código"
    },
    "form": {
      "title": "Nueva tarjeta regalo",
      "code": "Código",
      "initialAmount": "Monto inicial",
      "customerName": "Nombre del cliente",
      "notes": "Notas"
    },
    "amountForm": {
      "loadTitle": "Cargar saldo",
      "redeemTitle": "Redimir",
      "currentBalance": "Saldo actual: {balance}",
      "amount": "Monto",
      "notes": "Notas",
      "loadButton": "Cargar saldo",
      "redeemButton": "Redimir",
      "loadError": "No se pudo cargar el saldo",
      "redeemError": "No se pudo redimir el saldo"
    },
    "table": {
      "code": "Código",
      "customer": "Cliente",
      "balance": "Saldo actual",
      "status": "Estado",
      "createdAt": "Fecha de creación",
      "active": "Activa",
      "inactive": "Inactiva",
      "loadButton": "Cargar saldo",
      "loadAriaLabel": "Cargar saldo",
      "redeemButton": "Redimir",
      "redeemAriaLabel": "Redimir"
    }
  },
  "clientesPuntos": {
    "pageTitle": "Clientes — Programa de Puntos",
    "loadError": "No se pudieron cargar los clientes",
    "searchPlaceholder": "Buscar por nombre",
    "newButton": "Nuevo cliente",
    "createdToast": "{name} fue registrado",
    "createError": "No se pudo registrar el cliente",
    "lookup": {
      "title": "Consultar cliente",
      "codeLabel": "Cédula o código de tarjeta",
      "button": "Consultar",
      "notFound": "No se encontró un cliente con ese dato",
      "subtitle": "Cédula {identification}",
      "pointsSuffix": "{points} pts"
    },
    "form": {
      "title": "Nuevo cliente",
      "name": "Nombre",
      "identification": "Cédula",
      "cardCode": "Código de tarjeta",
      "phone": "Teléfono"
    },
    "earnForm": {
      "title": "Registrar compra",
      "amount": "Monto de la compra",
      "previewLabel": "Puntos a ganar",
      "notes": "Notas",
      "submitButton": "Registrar compra"
    },
    "earnedToast": "{name} ganó {points} puntos",
    "earnError": "No se pudo registrar la compra",
    "redeemedToast": "{name} redimió \"{reward}\"",
    "redeemError": "No se pudo redimir el premio",
    "redeemModal": {
      "title": "Redimir premio",
      "subtitle": "Saldo disponible: {balance} puntos",
      "confirmTitle": "¡Puedes redimir este premio!",
      "currentBalance": "Saldo actual",
      "cost": "Costo",
      "resultingBalance": "Saldo resultante",
      "notes": "Notas",
      "confirmButton": "Confirmar canje"
    },
    "table": {
      "name": "Nombre",
      "identification": "Cédula",
      "cardCode": "Código de tarjeta",
      "phone": "Teléfono",
      "pointsBalance": "Puntos",
      "createdAt": "Fecha de registro",
      "earnButton": "Registrar compra",
      "earnAriaLabel": "Registrar compra",
      "redeemButton": "Redimir premio",
      "redeemAriaLabel": "Redimir premio"
    }
  },
  "premios": {
    "pageTitle": "Premios",
    "pageSubtitle": "Catálogo de recompensas que tus clientes pueden redimir con sus puntos acumulados.",
    "loadError": "No se pudieron cargar los premios",
    "newButton": "Nuevo premio",
    "createdToast": "{name} fue creado",
    "updatedToast": "{name} fue actualizado",
    "deletedToast": "{name} fue eliminado",
    "saveError": "No se pudo guardar el premio",
    "deleteError": "No se pudo eliminar el premio",
    "deleteConfirmTitle": "Eliminar premio",
    "deleteConfirmMessage": "¿Estás seguro de que deseas eliminar \"{name}\"?",
    "addTitle": "Nuevo premio",
    "editTitle": "Editar premio",
    "noRewards": "Todavía no hay premios en el catálogo.",
    "form": {
      "name": "Nombre",
      "pointsCost": "Costo en puntos",
      "description": "Descripción",
      "descriptionPlaceholder": "Opcional",
      "active": "Activo"
    },
    "catalog": {
      "available": "Disponible",
      "inactive": "Inactivo",
      "points": "puntos",
      "shortfall": "Te faltan {points} puntos"
    }
  },
  "configuracionPuntos": {
    "pageTitle": "Configuración — Programa de Puntos",
    "pageSubtitle": "Define cuántos pesos equivalen a un punto para el programa de fidelidad.",
    "loadError": "No se pudo cargar la configuración",
    "saveError": "No se pudo guardar la configuración",
    "savedToast": "Configuración actualizada",
    "amountPerPoint": "Monto por punto",
    "amountPerPointHint": "Pesos necesarios para ganar 1 punto",
    "readOnlyNotice": "Solo un administrador puede editar este valor."
  },
  "estadoSincronizacion": {
    "pageTitle": "Estado de sincronización POS",
    "pageSubtitle": "Revisa qué facturas se han enviado a Sinutech POS y reenvía las que quedaron en cola o fallaron.",
    "statusPlaceholder": "Estado",
    "allStatuses": "Todos los estados",
    "loadError": "No se pudo cargar el estado de sincronización",
    "empty": "Todavía no hay facturas con intentos de sincronización.",
    "table": {
      "invoiceNumber": "N° Factura",
      "provider": "Proveedor",
      "status": "Estado",
      "syncedAt": "Última sincronización",
      "error": "Detalle del error",
      "resendButton": "Reenviar",
      "resendAriaLabel": "Reenviar a POS"
    }
  },
  "users": {
    "pageTitle": "Usuarios",
    "newButton": "Nuevo usuario",
    "addTitle": "Nuevo usuario",
    "editTitle": "Editar usuario",
    "deactivate": "Desactivar",
    "deactivateConfirmTitle": "Desactivar usuario",
    "deactivateConfirmMessage": "¿Estás seguro de que deseas desactivar a {name}?",
    "createdToast": "{name} fue creado",
    "updatedToast": "{name} fue actualizado",
    "deactivatedToast": "{name} fue desactivado",
    "loadError": "No se pudieron cargar los usuarios",
    "saveError": "No se pudo guardar el usuario",
    "deactivateError": "No se pudo desactivar el usuario",
    "table": {
      "name": "Nombre",
      "email": "Email",
      "role": "Rol",
      "status": "Estado",
      "active": "Activo",
      "inactive": "Inactivo",
      "editAriaLabel": "Editar usuario",
      "deactivateAriaLabel": "Desactivar usuario"
    },
    "form": {
      "name": "Nombre",
      "email": "Email",
      "password": "Contraseña",
      "passwordEditPlaceholder": "Dejar en blanco para no cambiar",
      "passwordTooShort": "La contraseña debe tener al menos 8 caracteres",
      "role": "Rol",
      "active": "Activo",
      "rolesLoadError": "No se pudieron cargar los roles disponibles."
    }
  }
}
